var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 41.3438C32.2355 41.3438 41.3438 32.2355 41.3438 21C41.3438 9.76446 32.2355 0.65625 21 0.65625C9.76446 0.65625 0.65625 9.76446 0.65625 21C0.65625 32.2355 9.76446 41.3438 21 41.3438Z","fill":"#000","key":0}),React.createElement("path",{"d":"M11.1562 14.4375V27.5625H30.8438V14.4375H11.1562ZM26.9719 16.4062L21 21.0656L15.0281 16.4062H26.9719ZM13.125 25.5938V17.4563L21 23.5594L28.875 17.4563V25.5938H13.125Z","fill":"white","key":1})]);
}

Email.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Email;

Email.default = Email;
